import { PFAProgramState } from '../models/pfaProgram';
import { pfaProgramDefaultState } from '../models/pfaProgramData';

export const pfaProgram = (state: PFAProgramState = pfaProgramDefaultState) => state;
